import { ContentCardLocation, FooterDisclosures } from './data';

class DisclosureInitializer {
  private listener?: (value: Record<string, string>) => void;

  private disclosures: FooterDisclosures = {};

  update(id: ContentCardLocation, value?: string) {
    this.disclosures[id] = value;

    if (this.listener) {
      this.listener(this.disclosures);
    }
  }

  subscribe(listener: (value: FooterDisclosures) => void) {
    this.listener = listener;
    this.listener(this.disclosures);
  }

  unsubscribe() {
    this.listener = undefined;
    this.disclosures = {};
  }
}

function initialize() {
  return new DisclosureInitializer();
}

export default initialize();
